import { memo } from "react";

import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

import { useApplicationContext } from "contexts/app";

const ElevatedButton = styled(Button)`
  z-index: 999;
`;

const ToggleSidebar = () => {
  const { collapsedSidebar: collapsed, onToggleSideBar } = useApplicationContext();

  return collapsed ? (
    <ElevatedButton type={"default"} icon={<MenuUnfoldOutlined />} onClick={() => onToggleSideBar()} />
  ) : (
    <ElevatedButton type={"default"} icon={<MenuFoldOutlined />} onClick={() => onToggleSideBar()} />
  );
};

export default memo(ToggleSidebar, () => true);
